const UPPERS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export const LOWERS = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];
const DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
const SPACES = [" ", "\n", "\t"];
const OTHERS = [
  "!",
  '"',
  "#",
  "$",
  "%",
  "&",
  "'",
  "(",
  ")",
  "*",
  "+",
  ",",
  "-",
  ".",
  "/",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "@",
  "[",
  "\\",
  "]",
  "^",
  "`",
  "{",
  "|",
  "}",
  "~",
];
export const ALL = [...UPPERS, ...LOWERS, ...DIGITS, " ", ...OTHERS, "_"];
export const CLASSES: { [key: string]: string[] } = {
  d: DIGITS,
  D: [...UPPERS, ...LOWERS, ...SPACES, ...OTHERS, "_"],
  w: [...UPPERS, ...LOWERS, ...DIGITS, "_"],
  W: [...SPACES, ...OTHERS],
  t: ["\t"],
  n: ["\n"],
  v: ["\u000B"],
  f: ["\u000C"],
  r: ["\r"],
  s: SPACES,
  S: [...UPPERS, ...LOWERS, ...DIGITS, ...OTHERS, "_"],
  "0": ["\0"],
};